const SignUpCard = ({ icon, title, description, buttonText, url }) => {
  return (
    <div className="p-8  rounded-lg border border-zinc-700 mb-6">
      {/* <img src={icon || "/placeholder.svg"} alt="" className="w-16 h-16 mb-4" /> */}
      <div className="w-full">{icon}</div>
      <h2 className="text-white text-2xl font-bold mb-3">{title}</h2>
      <p className="text-gray-300 mb-6 text-sm leading-relaxed max-w-md">
        {description}
      </p>
      <button
        onClick={() => {
          window.location.href = url;
        }}
        className="bg-[#F5A623] hover:bg-[#f5a623ee] text-white font-medium px-6 py-2 rounded-md transition-colors"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default SignUpCard;
